(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/login-qr-code.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/login-qr-code.js');
'use strict';

const QRCode = svs.components.libs.ReactQRCode;
const LoginQrCode = _ref => {
  let {
    qrCode,
    children,
    isError,
    errorMessage
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-qrcode-container u-flex u-flex-align-items-center u-flex-justify-content-center"
  }, !qrCode && isError && React.createElement("p", {
    "aria-live": "assertive",
    className: "login-react-error-message",
    role: "alert"
  }, errorMessage), qrCode && React.createElement("div", {
    "aria-label": "QR-kod f\xF6r inloggning",
    className: "login-react-qrcode"
  }, React.createElement(QRCode, {
    className: "margin-top",
    size: 120,
    value: qrCode
  }))), React.createElement("div", null, children));
};
svs.playerLoginReact.sharedComponents.LoginQrCode = LoginQrCode;

 })(window);